import type { ISelectedUser } from '@/apiClient/types/user'

import type { IIcons } from '@foundever/ui-lib'

/** Website access level selected in the publish modal. */
export type WebsiteVisibilityMode = 'foundever' | 'private' | 'password'

/** Matches ui-lib's `IDropdownItem` (label/value/icon) so it can feed a UIDropdown directly. */
export interface IWebsiteVisibilityOption {
  value: WebsiteVisibilityMode
  label: string
  description: string
  icon: IIcons
}

export interface PublishToWebFormValues {
  websiteName: string
  websiteDescription: string
  websiteSlug: string
  websitePassword: string
  visibilityMode: WebsiteVisibilityMode
  shareUsers: ISelectedUser[]
}

export function emptyPublishToWebFormValues(): PublishToWebFormValues {
  return {
    websiteName: '',
    websiteDescription: '',
    websiteSlug: '',
    websitePassword: '',
    visibilityMode: 'foundever',
    shareUsers: [],
  }
}
